import addAllEventListeners from './addAllEventListeners';
import clearElement from './clearElement';
import createElement from './createElement';
import createTemplateElement from './createTemplateElement';
import getParamByName from './getParamByName';
import isInIframe from './isInIframe';
import isTouchDevice from './isTouchDevice';

export {
  addAllEventListeners,
  clearElement,
  createElement,
  createTemplateElement,
  getParamByName,
  isInIframe,
  isTouchDevice,
};
